import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

const StreamingMeritAnime = {
  init() {
    if (ScrollTrigger.isTouch === 1) {
      ScrollTrigger.normalizeScroll({
        allowNestedScroll: "",
        type: "touch,wheel,pointer"
      });
    }

    // DOMの取得
    const merit = document.querySelector('.js-merit');
    const meritFrame = document.querySelector('.js-meritFrame');
    const meritItems = document.querySelectorAll('.js-meritItem');
    const navButtons = document.querySelectorAll('.js-meritNavButton');

    // matchMediaで768px以上のみ実行
    ScrollTrigger.matchMedia({
      "(min-width: 768px)": () => {
        const setupAnimation = () => {
          const offsets = Array.from(meritItems).map(item => {
            return item.offsetTop - meritItems[0].offsetTop;
          });

          const firstItemHeight = meritItems[0].offsetHeight;
          gsap.set(meritFrame, {
            height: firstItemHeight,
            position: 'relative',
          });

          meritItems.forEach((item, index) => {
            gsap.set(item, {
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              y: offsets[index]
            });
          });

          return offsets;
        };

        const offsets = setupAnimation();

        const scrollTriggerInstance = ScrollTrigger.create({
          trigger: meritFrame,
          start: 'center center',
          end: () => `+=${window.innerHeight * (meritItems.length + 0.5)}`,
          pin: merit,
          scrub: 1,
          onUpdate: (self) => {
            const progress = self.progress;
            const totalItems = meritItems.length;
            const animationRatio = 0.9;
            const animationProgress = Math.min(progress / animationRatio, 1);

            meritItems.forEach((item, index) => {
              if (index === 0) {
                gsap.set(item, {y: 0});
              } else {
                const itemStart = (index - 1) / (totalItems - 1);
                const itemEnd = index / (totalItems - 1);
                const itemProgress = Math.max(0, Math.min(1, (animationProgress - itemStart) / (itemEnd - itemStart)));

                gsap.set(item, {
                  y: offsets[index] * (1 - itemProgress),
                  zIndex: index
                });
              }
            });
          }
        });

        // ナビゲーションボタンのクリックイベント
        navButtons.forEach((button, index) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();

            const totalItems = meritItems.length;
            const targetProgress = index / (totalItems - 1);

            const start = scrollTriggerInstance.start;
            const end = scrollTriggerInstance.end;
            const targetScroll = start + ((end - start) * targetProgress);

            gsap.to(window, {
              scrollTo: targetScroll,
              duration: 1,
              ease: 'power2.inOut'
            });
          });
        });

        // クリーンアップ関数
        return () => {
          gsap.set([meritFrame, ...meritItems], { clearProps: "all" });
        };
      },
      
      // 767px以下の時の処理
      "(max-width: 767px)": () => {
        // スムーススクロールのみ有効化
        const navButtons = document.querySelectorAll('.js-meritNavButton');
        
        navButtons.forEach((button, index) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            
            const targetItem = meritItems[index];
            if (targetItem) {
              gsap.to(window, {
                scrollTo: {
                  y: targetItem,
                  offsetY: 0
                },
                duration: 1,
                ease: 'power2.inOut'
              });
            }
          });
        });
      }
    });
  }
};

export default StreamingMeritAnime;
